import { Type } from 'class-transformer';
import ParameterForGraph from './ParameterForGraph';

export default class LocoSectionWithParameters {
  public locoSection = ''

  @Type(() => ParameterForGraph)
  public parameters = new Array<ParameterForGraph>()
}
